module.exports = __webpack_public_path__ + "img/logo-organico-argentina.5556cfe6.png";